/* __next_internal_client_entry_do_not_use__ ProminentPrice auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { SERRANO } from "@faire/retailer-visitor-shared/consts/colors";
import { useGetSettingAndAssignUpdateSaleColorCopy } from "@faire/retailer-visitor-shared/settings/useSettingUpdateSaleColorCopy";
import { DEPRECATED_backwardsCompatibleValues, useStrictLocalization } from "@faire/web--source/common/localization";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Span as TypographySpan } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
var RecommendedRetailPricePromoText = function(param) {
    var originalPrice = param.originalPrice, wholesalePrice = param.wholesalePrice, retailPrice = param.retailPrice;
    var shouldUpdateAndAssignSaleColor = useGetSettingAndAssignUpdateSaleColorCopy();
    var renderPromoFormatting = function(chunk) {
        return /*#__PURE__*/ _jsx(TypographySpan, {
            color: shouldUpdateAndAssignSaleColor ? SERRANO : Decorative.shade.orange,
            variant: "subheadingSansMedium",
            style: {
                marginRight: getSpacing("1/2x")
            },
            children: chunk
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "9UNdnA",
                defaultMessage: [
                    {
                        type: 8,
                        value: "PromoFormatting",
                        children: [
                            {
                                type: 1,
                                value: "wholesaleAmountMoney"
                            }
                        ]
                    }
                ],
                values: {
                    PromoFormatting: renderPromoFormatting,
                    wholesaleAmountMoney: wholesalePrice
                }
            }),
            /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "75mZPc",
                defaultMessage: [
                    {
                        type: 8,
                        value: "StrikeThroughFormatting",
                        children: [
                            {
                                type: 1,
                                value: "originalAmountMoney"
                            }
                        ]
                    }
                ],
                values: {
                    StrikeThroughFormatting: renderStrikeThroughFormattingWithMargin,
                    TextFormatting: renderRegularChunk,
                    originalAmountMoney: originalPrice
                }
            }),
            /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "M0Bha1",
                defaultMessage: [
                    {
                        type: 8,
                        value: "TextFormatting",
                        children: [
                            {
                                type: 0,
                                value: "RRP "
                            },
                            {
                                type: 1,
                                value: "retailAmountMoney"
                            }
                        ]
                    }
                ],
                values: {
                    TextFormatting: renderRegularChunk,
                    retailAmountMoney: retailPrice
                }
            })
        ]
    });
};
var PromoText = function(param) {
    var originalPrice = param.originalPrice, wholesalePrice = param.wholesalePrice, retailPrice = param.retailPrice;
    var shouldUpdateAndAssignSaleColor = useGetSettingAndAssignUpdateSaleColorCopy();
    var renderPromoFormatting = function(chunk) {
        return /*#__PURE__*/ _jsx(TypographySpan, {
            color: shouldUpdateAndAssignSaleColor ? SERRANO : Decorative.shade.orange,
            variant: "subheadingSansMedium",
            style: {
                marginRight: getSpacing("1/2x")
            },
            children: chunk
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "1cmlq3",
                defaultMessage: [
                    {
                        type: 8,
                        value: "PromoFormatting",
                        children: [
                            {
                                type: 1,
                                value: "wholesaleAmountMoney"
                            }
                        ]
                    }
                ],
                values: {
                    PromoFormatting: renderPromoFormatting,
                    wholesaleAmountMoney: wholesalePrice !== null && wholesalePrice !== void 0 ? wholesalePrice : ""
                }
            }),
            /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "75mZPc",
                defaultMessage: [
                    {
                        type: 8,
                        value: "StrikeThroughFormatting",
                        children: [
                            {
                                type: 1,
                                value: "originalAmountMoney"
                            }
                        ]
                    }
                ],
                values: {
                    StrikeThroughFormatting: renderStrikeThroughFormattingWithMargin,
                    originalAmountMoney: originalPrice
                }
            }),
            /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "8EOVV1",
                defaultMessage: [
                    {
                        type: 8,
                        value: "TextFormatting",
                        children: [
                            {
                                type: 0,
                                value: "MSRP "
                            },
                            {
                                type: 1,
                                value: "retailAmountMoney"
                            }
                        ]
                    }
                ],
                values: {
                    TextFormatting: renderRegularLabelChunk,
                    retailAmountMoney: retailPrice
                }
            })
        ]
    });
};
var RecommendedRetailPriceText = function(param) {
    var wholesalePrice = param.wholesalePrice, retailPrice = param.retailPrice, small = param.small;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "+vpfaz",
                defaultMessage: [
                    {
                        type: 8,
                        value: "BoldFormatting",
                        children: [
                            {
                                type: 1,
                                value: "wholesaleAmountMoney"
                            }
                        ]
                    }
                ],
                values: {
                    BoldFormatting: small ? renderParagraphBoldFormatting : renderSubHeadingBoldFormatting,
                    wholesaleAmountMoney: wholesalePrice !== null && wholesalePrice !== void 0 ? wholesalePrice : ""
                }
            }),
            /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "HYugD1",
                defaultMessage: [
                    {
                        type: 8,
                        value: "TextFormatting",
                        children: [
                            {
                                type: 0,
                                value: "RRP "
                            },
                            {
                                type: 1,
                                value: "retailAmountMoney"
                            }
                        ]
                    }
                ],
                values: {
                    TextFormatting: renderRegularLabelChunkGray,
                    retailAmountMoney: retailPrice
                }
            })
        ]
    });
};
var PriceText = function(param) {
    var wholesalePrice = param.wholesalePrice, retailPrice = param.retailPrice;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "kQgUIs",
                defaultMessage: [
                    {
                        type: 8,
                        value: "WholesaleTextFormatting",
                        children: [
                            {
                                type: 1,
                                value: "wholesaleAmountMoney"
                            }
                        ]
                    }
                ],
                values: {
                    WholesaleTextFormatting: renderParagraphBoldFormattingWithMargin,
                    wholesaleAmountMoney: wholesalePrice !== null && wholesalePrice !== void 0 ? wholesalePrice : ""
                }
            }),
            /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "8EOVV1",
                defaultMessage: [
                    {
                        type: 8,
                        value: "TextFormatting",
                        children: [
                            {
                                type: 0,
                                value: "MSRP "
                            },
                            {
                                type: 1,
                                value: "retailAmountMoney"
                            }
                        ]
                    }
                ],
                values: {
                    TextFormatting: renderRegularLabelChunk,
                    retailAmountMoney: retailPrice
                }
            })
        ]
    });
};
var PriceBase = function(props) {
    var strictLocalize = useStrictLocalization().strictLocalize;
    if (props.showProductPromotions) {
        return /*#__PURE__*/ _jsx(Row, {
            gap: "1x",
            align: "center",
            justify: "center",
            "data-test-id": "promotion-text",
            "aria-label": strictLocalize({
                id: "YFDyy0",
                defaultMessage: [
                    {
                        type: 0,
                        value: "original price is "
                    },
                    {
                        type: 1,
                        value: "originalAmountMoney"
                    },
                    {
                        type: 0,
                        value: ", discounted price is "
                    },
                    {
                        type: 1,
                        value: "wholesaleAmountMoney"
                    }
                ]
            }, DEPRECATED_backwardsCompatibleValues({
                originalAmountMoney: props.originalPrice,
                wholesaleAmountMoney: props.wholesalePrice
            })),
            children: props.isUKRetailer ? /*#__PURE__*/ _jsx(RecommendedRetailPricePromoText, _object_spread({}, props)) : /*#__PURE__*/ _jsx(PromoText, _object_spread({}, props))
        });
    } else {
        return /*#__PURE__*/ _jsx(Row, {
            gap: "1x",
            align: "center",
            justify: "center",
            "data-test-id": "product-tile-msrp",
            children: props.isUKRetailer ? /*#__PURE__*/ _jsx(RecommendedRetailPriceText, _object_spread({}, props)) : /*#__PURE__*/ _jsx(PriceText, _object_spread({}, props))
        });
    }
};
export var ProminentPrice = function(props) {
    return /*#__PURE__*/ _jsx(PriceBase, _object_spread({}, props));
};
var renderRegularChunk = function(chunk) {
    return /*#__PURE__*/ _jsx(TypographySpan, {
        variant: "paragraphSansRegular",
        children: chunk
    });
};
var renderRegularLabelChunk = function(chunk) {
    return /*#__PURE__*/ _jsx(TypographySpan, {
        variant: "labelSansRegular",
        children: chunk
    });
};
var renderRegularLabelChunkGray = function(chunk) {
    return /*#__PURE__*/ _jsx(TypographySpan, {
        variant: "labelSansRegular",
        color: Core.text.subdued,
        style: {
            marginRight: getSpacing("1/2x")
        },
        children: chunk
    });
};
var renderParagraphBoldFormattingWithMargin = function(chunk) {
    return /*#__PURE__*/ _jsx(TypographySpan, {
        variant: "subheadingSansMedium",
        style: {
            marginRight: getSpacing("1/2x")
        },
        children: chunk
    });
};
var renderStrikeThroughFormattingWithMargin = function(chunk) {
    return /*#__PURE__*/ _jsx(StyledStrikethrough, {
        style: {
            marginRight: getSpacing("1/2x")
        },
        children: chunk
    });
};
var renderParagraphBoldFormatting = function(chunk) {
    return /*#__PURE__*/ _jsx(TypographySpan, {
        variant: "subheadingSansMedium",
        children: chunk
    });
};
var renderSubHeadingBoldFormatting = function(chunk, marginRight) {
    return /*#__PURE__*/ _jsx(TypographySpan, {
        variant: "subheadingSansMedium",
        style: {
            marginRight: marginRight
        },
        children: chunk
    });
};
var StyledStrikethrough = styled(TypographySpan).attrs({
    variant: "paragraphSansRegular"
}).withConfig({
    componentId: "sc-f38dce10-0"
})([
    "text-decoration:line-through;"
]);
